import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getApiUrl } from '../config/api';
import { theme } from '../config/theme';

const ForgotPassword: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setMessage(null);
    setLoading(true);

    try {
      const res = await fetch(`${getApiUrl()}/api/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Erro ao solicitar reset');

      setMessage(data.message || 'Se o email existir, você receberá instruções para redefinir sua senha');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro inesperado');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`min-h-screen flex items-center justify-center p-6 bg-gradient-to-br ${theme.colors.gradients.background}`}>
      <div className={theme.classes.card.elevated + " w-full max-w-md p-8"}>
        <h2 className="text-3xl font-bold text-ink-title dark:text-ink-title-dark mb-2">Esqueci minha senha</h2>
        <p className="text-sm text-ink-subtitle dark:text-ink-subtitle-dark mb-6">
          Informe o e-mail cadastrado e enviaremos um link para você redefinir a senha.
        </p>

        {message && (
          <div className={theme.classes.alert.success + " mb-4"}>
            {message}
          </div>
        )}

        {error && (
          <div className={theme.classes.alert.error + " mb-4"}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-ink-label dark:text-ink-label-dark mb-2">E-mail</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="seuemail@empresa.com"
              className={theme.classes.input.base}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className={theme.classes.button.primary + " w-full py-3"}
          >
            {loading ? 'Enviando...' : 'Enviar link de redefinição'}
          </button>

          <div className="text-center mt-4">
            <button
              type="button"
              onClick={() => navigate('/login')}
              className={theme.classes.link.primary + " text-sm"}
            >
              Voltar ao login
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
